import { render, staticRenderFns } from "./FacilitatorTools.vue?vue&type=template&id=d05b3a90&scoped=true"
import script from "./FacilitatorTools.vue?vue&type=script&lang=js"
export * from "./FacilitatorTools.vue?vue&type=script&lang=js"
import style0 from "./FacilitatorTools.vue?vue&type=style&index=0&id=d05b3a90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05b3a90",
  null
  
)

/* custom blocks */
import block0 from "./FacilitatorTools.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports